import { apiClient } from '../../api/interceptor';

/**
 * The value list behind a `values` header filter, for any table.
 *
 * One endpoint serves every table: it is told the model or table behind the
 * listing and scopes the values the way that table's listing is scoped (see
 * ColumnFilterController). So a table needs no API function and no
 * registration -- it passes `columnFilterSource="Message"` to TableManager and
 * this is used for it.
 *
 * A listing narrowed by something no column can express has a preset there and
 * passes its name instead; one that neither covers still passes its own
 * `columnFilterValuesFn`.
 */
export const getColumnFilterValues = (data) =>
  apiClient({
    method: 'POST',
    url: 'column-filter/values',
    data,
  });

/** Binds the shared endpoint to one table's model, table or preset name. */
export const makeColumnFilterValuesFn = (source) => (data) =>
  getColumnFilterValues({ ...data, source });
